module.exports = __webpack_public_path__ + "img/82-f2815c.png";